/*************************************************************************************************
 * Responsibility - Renders the navigation tabs under the preferences page and the corresponding
 * view via react-router-dom <Outlet />. If the naked route to this component is found in the
 * path it redirects to the contact page.
 * **************************************
 *
 * @format
 * */

import {ProductionPresets as ProductionPresetsComponents} from './production_presets/production_presets';
import withAccountDetailsHandler from './with_account_details_handler';
import {Contact as ContactComponent} from './contact/contact';
import {handleChange} from 'frontier-form';
import React from 'react';

// styles
import './container.scss';

export const Contact = withAccountDetailsHandler(
    handleChange(props => {
        return <ContactComponent {...props} />;
    })
);

export const ProductionPresets = withAccountDetailsHandler(
    handleChange(props => {
        return <ProductionPresetsComponents {...props} />;
    })
);
